import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import WpApi from '../../WpApi';
import _ from 'lodash'
import './../../assets/scss/membership/account.scss';
import Loader from '../common/Loader';
import { DASHBOARD_LINK, PAID_SERVICES } from '../../constants/constants';
import { titleCase } from 'title-case';

const PaymentMethods = () => {
    const [paymentMethods, setPaymentMethods] = useState(null);
    
    const fetchPaymentMethods = () => {
        WpApi.fetchPaymentMethods().then((data) => {
            data.length ? setPaymentMethods(data) : setPaymentMethods([])
        }).catch((error) => {
            setPaymentMethods([])
            console.error(error);
        })
    }

    const getLocaleDate = (t) => {
        const addZeroPadding = (number) => {
            return `${number}`.padStart(2,'0');
        }
        const locale_date = new Date();
        locale_date.setTime(parseInt(t) * 1000);
        const locale_time = addZeroPadding(locale_date.getHours()) + ":" + addZeroPadding(locale_date.getMinutes());
        return addZeroPadding(locale_date.getMonth() + 1) + "-" +  addZeroPadding(locale_date.getDate()) + "-" + locale_date.getFullYear() + ", " + locale_time;
    }

    useEffect(() => {
        fetchPaymentMethods();
    },[]);

    if(!PAID_SERVICES) return <Redirect to={DASHBOARD_LINK} />
    
    if(paymentMethods == null){
        return (
            <div className="my-account-screen">
                <div className="outer-wrapper">
                    <div className="shadow-box">
                        <Loader className="set-loader-size"></Loader>
                    </div>
                </div>
            </div>
        )
    }

    return(
        <>
        <div className="my-account-screen">
            <div className="outer-wrapper payment-method-screen">
                <h2>My Payment Methods</h2>
                {paymentMethods?.length === 0 && <div className="shadow-box invoice-box payment-method-box remove-bg-color">
                    <section className="invoice-list payment-method-list">
                        <div className="row header">
                            <div className="column">Payment method not found!</div>
                        </div>
                    </section>
                </div>} 
                {paymentMethods?.length > 0 && <div className="payment-method-table">
                    <table className="table-inner">
                        <thead>
                            <tr>
                                <th className="col-one pay-col">Card</th>
                                <th className="col-two pay-col">Type</th>
                                <th className="col-three pay-col">Last 4 digits</th>
                                <th className="col-four pay-col">Expiration</th>
                                <th className="col-five pay-col">Added on</th>
                            </tr>
                        </thead>
                        <tbody>
                        {paymentMethods?.map((item, key) => {
                            return(
                            <tr className="list" key={key}>
                                <td className="col-one pay-col">{titleCase(item.card.display_brand.split('_').join(' '))}</td>
                                <td className="col-two pay-col">{titleCase(item.card.funding)}</td>
                                <td className="col-three pay-col">{item.card.last4}</td>
                                <td className="col-four pay-col">{`${item.card.exp_month}/${item.card.exp_year}`}</td>
                                <td className="col-five pay-col">{getLocaleDate(item.created)}</td>
                            </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>}
            </div>
        </div>
        </>
    )
}

export default PaymentMethods;